import { render } from "./index.vue?vue&type=template&id=022aecd2&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=022aecd2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-022aecd2"

export default script